import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { imagesApi } from '../api/client'

const KEY = ['admin', 'images']

export function useImageCatalog() {
  return useQuery({ queryKey: KEY, queryFn: imagesApi.catalog })
}

export function useAvailableImages() {
  return useQuery({ queryKey: ['images', 'available'], queryFn: imagesApi.available })
}

function useInvalidating<TArgs>(fn: (args: TArgs) => Promise<unknown>) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: fn,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEY })
      qc.invalidateQueries({ queryKey: ['instances'] })
    },
  })
}

export function useAddImage() {
  return useInvalidating(({ ref, notes }: { ref: string; notes: string }) =>
    imagesApi.create(ref, notes),
  )
}

/** Withdraw a row from selection (or put it back) without deleting it. */
export function useUpdateImage() {
  return useInvalidating(({ id, enabled, notes }: { id: string; enabled: boolean; notes: string }) =>
    imagesApi.update(id, enabled, notes),
  )
}

export function useSetDefaultImage() {
  return useInvalidating((id: string) => imagesApi.setDefault(id))
}

export function useDeleteImage() {
  return useInvalidating((id: string) => imagesApi.remove(id))
}

export function useSwapImage() {
  return useInvalidating(({ instanceId, imageId }: { instanceId: string; imageId: string }) =>
    imagesApi.swap(instanceId, imageId),
  )
}

export function useRollbackImage() {
  return useInvalidating((instanceId: string) => imagesApi.rollback(instanceId))
}
